/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
import { components } from "@/lib/api/openAPITypesV1";
import { API, API_2, APILocal, APIStaging } from "../config/axios";

class ResponderCompany {
  getOverViewCompanies = async (
    pageNumber: number,
    pageSize: number,
    name: string | null = null
  ) => {
    let queryParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (name) {
      queryParams += `&name=${encodeURIComponent(name)}`;
    }
    const { data } = await API.get<PaginatedCompaniesResponse>(
      `Admin_ResponderCompany?${queryParams}`
    );
    return data;
  };

  getAllResponderCompanies = async (): Promise<IBasicResponderCompanyDto[]> => {
    const response = await API.get<PaginatedResponse<IBasicResponderCompanyDto>>(
      "Admin_ResponderCompany?pageNumber=1&pageSize=100"
    );
    return response.data.data;
  };

  async updateCompany(company: IResponderCompanyUpdateRequest) {
    try {
      const response = await API_2.put<APIResult<IResponderCompany>>(
        `/Admin_ResponderCompany`,
        company,
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async createCompany(company: ICreateResponderCompanyDto) {
    try {
      const response = await API_2.post<APIResult<ICreateResponderCompanyDto>>(
        `/Admin_ResponderCompany`,
        company,
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  getResponderAdmin = async (userId: number | undefined) => {
    const { data } = await API.get<IResponderAdmin>(
      `Admin_UserAuth/GetResponderAdminAsync/${userId}`,
    );
    return data;
  };

  getResponderCompanyById = async (companyId: number) => {
    try {
      const { data } = await API.get<IResponderCompany>(
        `Admin_ResponderCompany/${companyId}`,
      );
      console.log("Edit responder company data", data);
      return data;
    } catch (error) {
      console.error("Error fetching responder company:", error);
      return null;
    }
  };

  getPendingAssociations = async (
    pageNumber: number = 1,
    pageSize: number = 10,
  ): Promise<PendingAssociationsResponse> => {
    try {
      const queryParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      const { data } = await API.get<PendingAssociationsResponse>(
        `ResponderCompany/pending-associations?${queryParams}`,
        {
          headers: {
            "X-API-Version": "2.0",
          },
        },
      );
      return data;
    } catch (error) {
      console.error("Error fetching pending associations:", error);
      throw error;
    }
  };

  getAllAssociations = async (
    pageNumber: number = 1,
    pageSize: number = 10,
  ): Promise<AllAssociationsResponse> => {
    try {
      const queryParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      const { data } = await API.get<AllAssociationsResponse>(
        `ResponderCompany/all-associations?${queryParams}`,
        {
          headers: {
            "X-API-Version": "2.0",
          },
        },
      );
      return data;
    } catch (error) {
      console.error("Error fetching all associations:", error);
      throw error;
    }
  };

  getAssociationStats = async (): Promise<AssociationStatsResponse> => {
    try {
      const { data } = await API.get<AssociationStatsResponse>(
        `ResponderCompany/association-stats`,
        {
          headers: {
            "X-API-Version": "2.0",
          },
        },
      );
      return data;
    } catch (error) {
      console.error("Error fetching association stats:", error);
      throw error;
    }
  };

  processCompanyRequest = async (
    request: IApproveRejectCompanyRequest,
  ): Promise<CompanyRequestResponse> => {
    try {
      const { data } = await API.post<CompanyRequestResponse>(
        `ResponderCompany/company-request`,
        request,
        {
          headers: {
            "X-API-Version": "2.0",
          },
        },
      );
      return data;
    } catch (error) {
      console.error("Error processing company request:", error);
      throw error;
    }
  };
}

export default new ResponderCompany();
